import { ReactNode } from 'react';

interface SlideContentProps {
  'children': ReactNode;
  'headerText': ReactNode;
  'headerSubText'?: ReactNode;
  'centerHeader'?: boolean;
  'data-testid'?: string;
  'headerAction'?: ReactNode;
}

export function SlideContent({
  children,
  headerText,
  headerSubText,
  centerHeader = false,
  'data-testid': dataTestId,
  headerAction,
}: SlideContentProps) {
  return (
    <div className="pt-2 md:pt-9">
      <div className="mx-auto flex max-w-4xl flex-col text-gray-800">
        <div className="relative mt-3 w-full flex-none">
          <SlideHeader
            headerText={headerText}
            centerHeader={centerHeader}
            dataTestId={dataTestId}
            headerAction={headerAction}
          />
          {headerSubText && (
            <SlideSubHeader
              headerSubText={headerSubText}
              centerHeader={centerHeader}
            />
          )}
        </div>
        {children}
      </div>
    </div>
  );
}

interface SlideHeaderProps {
  headerText: ReactNode;
  centerHeader?: boolean;
  dataTestId?: string;
  headerAction?: ReactNode;
}

function SlideHeader({
  headerText,
  centerHeader = false,
  dataTestId,
  headerAction,
}: SlideHeaderProps) {
  return (
    <div
      className={`flex flex-col items-center px-2 md:flex-row md:items-start md:justify-between md:px-0 ${
        centerHeader ? 'text-center' : ''
      }`}
      data-testid={dataTestId}
    >
      <h1
        className={`text-lg font-semibold leading-tight text-gray-800 md:text-4xl ${
          centerHeader ? 'w-full' : ''
        }`}
      >
        {headerText}
      </h1>

      {headerAction && <div className="mt-4 shrink-0 md:ml-4 md:mt-0">{headerAction}</div>}
    </div>
  );
}

interface SlideSubHeaderProps {
  headerSubText: ReactNode;
  centerHeader?: boolean;
}

function SlideSubHeader({ headerSubText, centerHeader = false }: SlideSubHeaderProps) {
  return (
    <h3
      className={`mt-2 pt-1 text-base font-normal leading-7 text-gray-700 md:mt-1 md:text-xl/8 ${centerHeader ? 'text-center' : ''}`}
    >
      {headerSubText}
    </h3>
  );
}
